import Calculator from "./calculator"

export default Calculator